import { ThemeOptions } from '@material-ui/core/styles'

const staticImagePath = '/static/images/standalone/eve/'
const imagePath = 'https://ik.imagekit.io/utoniq/www/standalone/eve/'

/**
 * Eve Standalone Theme
 */
const EveTheme: ThemeOptions = {
  typography: {
    fontFamily: 'Hiragino Kaku Gothic Pro',
    h1: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '18px',
    },
    h2: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '16px',
    },
    h3: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '14px',
    },
    subtitle1: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '12px',
    },
    subtitle2: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '11px',
    },
    body1: {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '14px',
    },
    body2: {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '12px',
    },
    button: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '16px',
    },
    caption: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '10px',
    },
    overline: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '9px',
    },
  },
  palette: {
    primary: {
      main: '#658176',
      dark: '#475A53',
      light: '#D8D1C7',
    },
    secondary: {
      main: '#DD8609',
      light: '#D8D1C7',
    },
    grey: {
      50: '#FAFAFA',
      100: '#F5F5F5',
      200: '#EEEEEE',
      300: '#EEEEEE',
      400: '#BDBDBD',
      500: '#9E9E9E',
      600: '#9E9E9E',
      700: '#616161',
      800: '#424242',
      900: '#212121',
    },
    info: {
      main: '#FFE700',
      dark: '#000000',
    },
    error: {
      main: '#FF0000',
    },
    text: {
      primary: '#222222',
      secondary: '#999999',
    },
    textLight: {
      primary: '#FFFFFF',
    },
    background: {
      primary: '#D8D1C7',
      secondary: '#F4F4F4',
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 28,
        paddingTop: 12,
        paddingBottom: 12,
      },
      sizeSmall: {
        paddingTop: 8,
        paddingBottom: 8,
      },
      outlined: {
        paddingTop: 12,
        paddingBottom: 12,
        color: '#475A53',
        borderColor: '#658176',
      },
    },
    MuiListItem: {
      container: {
        listStyleType: 'none',
      },
    },
  },
  shadows: [
    'none',
    '0px 4px 8px rgba(0,0,0,0.08)',
    '0px 8px 16px -8px rgba(0,0,0,0.32)',
    '0px 12px 24px -12px rgba(0,0,0,0.56)',
    '0px 24px 48px -24px rgba(0,0,0,0.8)',
    '0px 24px 48px -24px rgba(0,0,0,0.8)',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  shape: {
    borderRadius: 4,
  },
  props: {
    MuiTypography: {},
    MuiAppBar: {
      elevation: 0,
    },
    MuiInputLabel: {},
  },
  assets: {
    menuIcon: {
      mypage: imagePath + 'menuicon/mypage.png',
      collection: imagePath + 'menuicon/collection.png',
      gacha: imagePath + 'menuicon/gacha.png',
      mission: imagePath + 'menuicon/mission.png',
    },
    collection: {
      secret: imagePath + 'collection/secret.png',
    },
    mission: {
      clear: imagePath + 'mission/clear.png',
      notClear: imagePath + 'mission/not_clear.png',
      decoration: imagePath + 'mission/decoration.png',
      correct: imagePath + 'mission/correct.png',
      incorrect:
        'https://ik.imagekit.io/utoniq/www/standalone/mission/incorrect.png',
    },
    backgrounds: {
      signup: imagePath + 'backgrounds/signup.jpg',
      home: staticImagePath + 'backgrounds/home.png',
      collections: {
        jeION6Ghh32XefK6iUQU:
          imagePath + 'backgrounds/collections/jeION6Ghh32XefK6iUQU.jpg',
        DB5C77LLpNd7VXtEr2mr:
          imagePath + 'backgrounds/collections/DB5C77LLpNd7VXtEr2mr.jpg',
        vUlQrkQGnW1y0OaaegON:
          imagePath + 'backgrounds/collections/vUlQrkQGnW1y0OaaegON.jpg',
      },
      items: {
        jeION6Ghh32XefK6iUQU:
          imagePath + 'backgrounds/items/jeION6Ghh32XefK6iUQU.jpg',
        DB5C77LLpNd7VXtEr2mr:
          imagePath + 'backgrounds/items/DB5C77LLpNd7VXtEr2mr.jpg',
        vUlQrkQGnW1y0OaaegON:
          imagePath + 'backgrounds/items/vUlQrkQGnW1y0OaaegON.jpg',
      },
      mission: imagePath + 'backgrounds/mission.jpg',
    },
    logoMedium: imagePath + 'logo_medium.png',
    logoMediumReverse: imagePath + 'logo_medium_reverse.png',
    logoSmall: imagePath + 'logo_small.png',
    logoSmallReverse: imagePath + 'logo_small_reverse.png',
    gachaTicket: imagePath + 'gacha_ticket.png',
    rewardGachaTicket: imagePath + 'reward_gacha_ticket.png',
    iconLoader: imagePath + 'icon_loader.gif',
    error: imagePath + 'error.png',
    agreement: imagePath + 'agreement.png',
    loading: staticImagePath + 'loading.png',
  },
  customStyle: {
    VoiceIcon: {
      innerCircle: {
        border: '1px dashed #FFFFFF',
        borderRadius: '50%',
      },
    },
    Chip: (colorCode = '#658176'): React.CSSProperties => {
      return {
        background: `
          linear-gradient(60deg,  transparent 8px, ${colorCode} 8px),
          linear-gradient(120deg, transparent 8px, ${colorCode} 8px),
          linear-gradient(240deg, transparent 8px, ${colorCode} 8px),
          linear-gradient(300deg, transparent 8px, ${colorCode} 8px);
        `,
        backgroundPosition: 'bottom left, top left, top right, bottom right',
        backgroundSize: '50% 50%',
        backgroundRepeat: 'no-repeat',
        borderRadius: 0,
      }
    },
    ErrorBase: {
      background: {
        right: 0,
      },
    },
  },
}

export default EveTheme
